import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { hasPrivilege, canEditServersPage } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import { selectedSome } from '../../stores/tables/selectors';
import TableToolbar from '../table/TableToolbar';

import CopyServerAction from './actions/CopyServerAction';
import DeleteServersAction from './actions/DeleteServersAction';
import GenerateNewKeysAction from './actions/GenerateNewKeysAction';

interface Props extends LocalizeContextProps, RouteComponentProps {
    selectedSome: boolean;
    hasPrivilege: (privileges: string[]) => boolean;
    canEdit: boolean;
}

interface State {
    showActions: boolean;
}

class ServersToolbar extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showActions: false
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.canEdit) {
            return (
                <TableToolbar>
                    {this.renderActionMenu()}
                    <Button
                        color="primary"
                        className="action-btn"
                        onClick={() => {
                            this.props.history.push(`/servers/new`);
                        }}
                    >
                        <FontAwesomeIcon
                            className="mr-4"
                            icon={['fal', 'plus']}
                        />
                        {t('servers.button.add')}
                    </Button>
                </TableToolbar>
            );
        } else {
            return null;
        }
    }

    private renderActionMenu = () => {
        const t = this.props.translate;
        const menuItems = _.compact(this.renderActions());

        if (menuItems.length > 0) {
            return (
                <ButtonDropdown
                    id="action-buttons"
                    className="action-btn"
                    color="default"
                    title={t('servers.button.actions') as string}
                    isOpen={this.state.showActions}
                    toggle={() => { this.setState({ showActions: !this.state.showActions }); }}
                    style={{ marginRight: '10px' }}
                >
                    <DropdownToggle caret={true}>
                        {t('servers.button.actions')}
                    </DropdownToggle>
                    <DropdownMenu persist={true}>
                        {menuItems}
                    </DropdownMenu>
                </ButtonDropdown>
            );
        } else {
            return <div />;
        }
    }

    private renderActions = () => {
        const t = this.props.translate;
        if (this.props.selectedSome) {
            return (
                [
                    <CopyServerAction key={1} />, // TODO
                    <GenerateNewKeysAction key={2} />, // TODO
                    <DeleteServersAction key={3} />, // TODO 
                ]
            );

        } else {
            return [];
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    selectedSome: selectedSome(state, 'servers'),
    canEdit: canEditServersPage(state)
});

export default connect(mapStateToProps)(withLocalize(withRouter(ServersToolbar)));